import StructureProductIcon from './StructureProductIcon.jsx'

export default function ProductFamilyIcon({ product, children, ...props }) {
  if (product === 'valve' || product === 'water') {
    return <StructureProductIcon product={product === 'valve' ? 'trv' : 'timer'} strokeWidth="1" data-family-product={product} {...props}>{children}</StructureProductIcon>
  }

  return <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-family-product={product} {...props}>
    {children}
    {product === 'panel' && <>
      <rect x="2.5" y="3.5" width="19" height="17" rx="2" />
      <rect x="5.5" y="6.5" width="13" height="7.5" rx=".75" />
      {[6, 10, 14, 18].map(x => <circle key={x} cx={x} cy="17.25" r=".85" />)}
    </>}
    {product === 'sensor' && <>
      <rect x="10" y="2" width="10" height="20" rx="3.5" />
      <circle cx="15" cy="17.5" r=".65" />
      <rect x="3" y="14" width="4.5" height="8" rx="1.6" />
    </>}
    {product === 'control' && <>
      <rect x="1.5" y="7" width="21" height="10" rx="1.4" />
      <path d="M20.5 7V3" />
      <path d="M4 9.75h16" />
      {[4.5, 8.5, 12.5, 16.5].map(x => <rect key={x} x={x} y="12.25" width="3" height="2.75" rx=".25" />)}
    </>}
    {product === 'plug' && <>
      <rect x="4" y="2" width="16" height="20" rx="4" />
      <rect x="6.5" y="4" width="11" height="3.5" rx="1.4" />
      <circle cx="12" cy="14.8" r="5.1" />
      <circle cx="10.1" cy="14.8" r=".6" />
      <circle cx="13.9" cy="14.8" r=".6" />
    </>}
  </svg>
}
